import {createFileRoute} from '@tanstack/react-router'
import AmericanosView_Create from "../../../americanos/AmericanosView_Create.tsx";

// The activation (payment) step's own path — query-less so it can be targeted by AdSense
// Offerwall URL rules. Renders the same wizard; it restores the stashed build straight into
// step 2, or falls back to the create form when there is nothing to activate.
export const Route = createFileRoute('/_app/americanos/activate')({
    component: RouteComponent,
})

function RouteComponent() {
    return <AmericanosView_Create />
}
